module.exports = __webpack_public_path__ + "static/img/0768.610391c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0768.jpg
// module id = 106
// module chunks = 0